export const REQUEST_ASSESSMENT_DATA = "REQUEST_ASSESSMENT_DATA";
export const RECEIVE_ASSESSMENT_DATA = "RECEIVE_ASSESSMENT_DATA";
export const SHOW_LOADER = "SHOW_CYBERRISK_PROFILE_SERVICE_LOADER";

export interface ICyberRiskAssessmentState {
    assessmentData?: IAssessmentData;
    isLoading: boolean;
}

export interface IAssessmentData {
    AssesmentDate?: string;
    HasTakenAssessment?: boolean;
    AssessmentSummary?: IAssessmentSummary;
    AssessmentScores?: IAssessmentScores;
    RecommendedBundles?: IRecommendedBundles[];
    Text?: string[];
    HasError?: boolean;
    Errors: string[];
    CaseId: string;
}

export interface IAssessmentSummary {
    Industry?: string;
    Locations?: string;
    Employees?: string;
    Interactions?: string;
}

export interface IAssessmentScores {
    Maturity?: string;
    Scale?: string;
    CyberPath?: string;
}

export interface IRecommendedBundles {
    Type?: string;
    Description?: string;
    Products?: IProducts[];
}

export interface IProducts {
    Id?: string;
    Name?: string;
    Description?: string;
    VendorDetails?: {};
    ProductImageURL?: string;
    categories?: ICategories[];
}

export interface ICategories {
    id?: string;
    description?: string;
}

export interface IGetAssessmentDataAction {
    type: "RECEIVE_ASSESSMENT_DATA";
    assessmentData: IAssessmentData;
}
export interface IRequestAssessmentDataAction {
    type: "REQUEST_ASSESSMENT_DATA";
}

export type KnownAction = IGetAssessmentDataAction | IRequestAssessmentDataAction;
